import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const secondaryTextColor = useColorModeValue('gray.500', 'gray.400');

  return {
    backgroundCardColor,
    textColor,
    borderColor,
    inputColor,
    secondaryTextColor,
  };
};
